import { Directive, HostListener } from '@angular/core';
import { Location } from '@angular/common';

@Directive({
  selector: 'button[appBack]'
})
export class BackDirective {
  constructor(private location: Location) { }

  @HostListener('click', ['$event.target'])
  onClick(el) {
    console.log('Clicked!', el);
    this.location.back();
  }
}